import FleetIssues from "../../../components/FleetIssues";

const FleetIssuesPage = () => {
  return (
      <FleetIssues />
  );
};

export default FleetIssuesPage;
